import { useCallback } from 'react';
import type { BoxBlurValue } from '../../lib/filters/box-blur';
import type { AdjustmentPanelProps } from '../adjustments/registry';
import { RangeRow } from '../adjustments/RangeRow';

/** Box Blur panel — single radius slider. Box uses a sliding-window
 *  sum so cost is independent of radius, which lets us push the
 *  range further than Gaussian without preview lag. */
export function BoxBlurPanel({ value, onChange }: AdjustmentPanelProps<BoxBlurValue>) {
  const set = useCallback(
    (patch: Partial<BoxBlurValue>) => onChange({ ...value, ...patch }),
    [onChange, value],
  );

  return (
    <div className="space-y-3">
      <RangeRow
        label="Radius"
        min={0}
        max={200}
        step={1}
        value={value.radius}
        onChange={(v) => set({ radius: v })}
      />
    </div>
  );
}
